// extracted by LIB_CSS_EXTRACT_LOADER
import "./loading-overlay_module.css"
export default {"overlay":"overlay-kF4wNA","blur":"blur-LuLfmA","spinner":"spinner-KTfJu3"};